import homeScreenReducer from "./homeScreenReducer";
import { combineReducers } from "redux";
import kciDetailsReducer from "./kciDetailsReducer";

const reducer = combineReducers({
  homeScreen: homeScreenReducer,
  kciDetails: kciDetailsReducer,
});

export default reducer;

export type RootState = ReturnType<typeof reducer>;
